"use strict";
import {
  SpamCode as SearchSpamCode,
  SearchType
} from "@uniswap/client-search/dist/search/v1/api_pb";
import { NATIVE_CHAIN_ID } from "constants/tokens";
import { useMemo } from "react";
import { useSearchTokensQuery } from "uniswap/src/data/rest/searchTokens";
import { parseProtectionInfo, parseSafetyLevel } from "uniswap/src/data/rest/utils";
import { useEnabledChains } from "uniswap/src/features/chains/hooks/useEnabledChains";
import { isUniverseChainId } from "uniswap/src/features/chains/types";
import { isBackendSupportedChain, toGraphQLChain } from "uniswap/src/features/chains/utils";
function mapSearchToken(token) {
  if (!isUniverseChainId(token.chainId)) {
    return void 0;
  }
  const chain = toGraphQLChain(token.chainId);
  if (!chain) {
    return void 0;
  }
  return {
    chain,
    address: token.address === "ETH" ? NATIVE_CHAIN_ID : token.address,
    decimals: token.decimals,
    symbol: token.symbol,
    name: token.name,
    feeData: token.feeData ? {
      buyFeeBps: token.feeData.buyFeeBps !== void 0 && token.feeData.buyFeeBps !== null ? String(token.feeData.buyFeeBps) : void 0,
      sellFeeBps: token.feeData.sellFeeBps !== void 0 && token.feeData.sellFeeBps !== null ? String(token.feeData.sellFeeBps) : void 0
    } : void 0,
    protectionInfo: parseProtectionInfo(token.protectionInfo),
    project: {
      logoUrl: token.logoUrl,
      name: token.projectName ?? token.name,
      safetyLevel: parseSafetyLevel(token.safetyLevel),
      isSpam: token.spamCode !== SearchSpamCode.NOT_SPAM
    }
  };
}
function isExploreSupportedToken(token) {
  return token !== void 0 && isBackendSupportedChain(token.chain);
}
export function useSearchTokensGql(searchQuery = "") {
  const { chains } = useEnabledChains();
  const { data, error, isPending } = useSearchTokensQuery({
    input: {
      searchQuery,
      chainIds: chains,
      searchType: SearchType.TOKEN,
      page: 1,
      size: 8
    },
    enabled: searchQuery !== ""
  });
  return useMemo(() => {
    const sortedTokens = data?.tokens?.map(mapSearchToken).filter(isExploreSupportedToken) ?? [];
    return { data: sortedTokens, loading: isPending, error };
  }, [data?.tokens, error, isPending]);
}
